import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import LaundryPassPurchaseReportCard from "../../../admin/components/report/LaundryPassPurchaseReportCard";

const LaundryPassPurchaseReport = ({ token, client }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!client || !client.laundry_pass_purchase_report) {
            history.push('/client')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <LaundryPassPurchaseReportCard
                        token={token}
                        role="client"
                        operators={client.admin}
                        distributors={client.distributor}
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
	return {
		client: state.client.client,
		token: state.client.token
	};
};

export default connect(mapStateToProps, null)(LaundryPassPurchaseReport);